import { Separator } from "@/components/ui/separator";

const ProjectDisclaimer = () => (
  <div className="w-full mt-8">
    <Separator className="mb-4" />
    <p className="text-xs text-muted-foreground text-center max-w-3xl mx-auto px-4 leading-relaxed">
      AILens is a completed research project implementing insights from published AI visibility studies (Jan-Feb 2026). 
      Scores reflect a point-in-time snapshot and may vary between scans. 
      This tool is provided as-is, without warranty.{" "}
      <a 
        href="mailto:hello@ai-lens.app" 
        className="underline hover:text-foreground transition-colors"
      >
        Questions?
      </a>
    </p>
  </div>
);

export default ProjectDisclaimer;
